// Don't touch this file
// All the application related js code has to go in ./application.js

// Exposed modules. Last imported override the first one.
import 'surveylabJsAssets/_exposed-modules';
import './_exposed-modules';
// Layers entrypoints
import surveylab from 'surveylabJsAssets/_surveylab';
import application from './_application';

surveylab();
application();